import { QueryClient } from '@tanstack/react-query';

import type { DefaultQueryOptions } from '~/modules/query-client/types';

export function createQueryClient(queryDefaults: DefaultQueryOptions = {}) {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60, // 1 minute
        retry: 0,
        ...queryDefaults,
      },
      mutations: { retry: 0 },
    },
  });
}
